import React, { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { USER_CHANNEL_SUBSCRIPTIONS } from '../../../gql/users';
import { isSubscriptionActive } from '../../../utils/channelSubscriptions.utils';
import { useActivityLogger } from '../../hooks/use-activity-logger';
import { Subscriptions } from './Subscriptions';
import Loader from 'components/ui/LoadingIndicator';

const SubscriptionsPage = () => {
    const pageLoadComplete = useActivityLogger(
        'Subscriptions',
        'Subscriptions',
        undefined,
        true
    );
    const queryChannelSubscriptions = useQuery(USER_CHANNEL_SUBSCRIPTIONS, {
        fetchPolicy: 'network-only',
    });
    const [stripeCardUpdatingLoader, setStripeCardUpdatingLoader] =
        useState(false);

    const refetchQuerySubscriptions = () => {
        setStripeCardUpdatingLoader(true);
    };

    useEffect(() => {
        if (!stripeCardUpdatingLoader) return;
        const refetchSubscriptionsData = setTimeout(
            () => queryChannelSubscriptions.refetch(),
            1000
        );
        const hideLoader = setTimeout(
            () => setStripeCardUpdatingLoader(false),
            2000
        );

        return () => {
            clearTimeout(refetchSubscriptionsData);
            clearTimeout(hideLoader);
        };
    }, [stripeCardUpdatingLoader, queryChannelSubscriptions]);

    const activeChannelSubscriptions = useMemo(() => {
        if (!queryChannelSubscriptions.data) return [];

        return queryChannelSubscriptions.data.me.channelSubscriptions.filter(
            isSubscriptionActive
        );
    }, [queryChannelSubscriptions.data]);

    if (queryChannelSubscriptions.loading) return <Loader />;

    pageLoadComplete();
    const hasSubscriptions = activeChannelSubscriptions.length > 0;

    return (
        <Subscriptions
            hasSubscriptions={hasSubscriptions}
            channelSubscriptions={activeChannelSubscriptions}
            refetchQuerySubscriptions={refetchQuerySubscriptions}
        />
    );
};

export default SubscriptionsPage;
